import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntClosedTagComponent} from "./int-closed-tag.component";
import {IntIconModule} from "../../int-icon";

@NgModule({
  imports: [
    CommonModule,
    IntIconModule
  ],
  declarations: [
    IntClosedTagComponent
  ],
  exports: [
    IntClosedTagComponent
  ]
})
export class IntClosedTagModule {}
